import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { IPOData, IPurchaseOrder_New } from 'src/app/modules/po-buyer/models';
import { PoBuyerService } from 'src/app/modules/po-buyer/services/po-buyer.service';
import { SupplierHelperService } from 'src/app/modules/supplier/services/supplier-helper.service';
import { SupplierService } from 'src/app/modules/supplier/services/supplier.service';

@Component({
  selector: 'app-delivery-followup-response',
  templateUrl: './delivery-followup-response.component.html',
  styleUrls: ['./delivery-followup-response.component.scss']
})
export class DeliveryFollowupResponseComponent implements OnInit {

  public title !: string;
  public purchaseOrders : Array<IPurchaseOrder_New> = [];
  public deliveryAck:any;
  public onClose = new Subject<boolean>();

  // form group
  public feedbackForm !: FormGroup;

  constructor(
    public bsModalRef: BsModalRef,
    private _poBuyerService : PoBuyerService,
    private _toastr : ToastrService,
    private _supplierService : SupplierService,
    private _helperService : SupplierHelperService) { }

  ngOnInit(): void {
    this.purchaseOrders.length && this.prepareForm();
    console.log(this.purchaseOrders);
    this._supplierService.getDeliveryAck(this.purchaseOrders[0].po_data[0].po_number).subscribe((res:any)=>{
      this.deliveryAck = res.data
    })
  }

  public onModalClose(): void {
    this.bsModalRef.hide();
  }

  public closeModal(data ?: any) {
    this.onClose.next(data);
    this.bsModalRef.hide();
  }

  getFormArrayName(prop: string): any {
    const formArr =  this.feedbackForm.controls[prop] as FormGroup;
    return formArr.controls
  }

  private prepareForm() : void {
    this.feedbackForm = this._helperService.prepareDeliveryFollowUpFeedbackForm(this.purchaseOrders);
    console.log(this.feedbackForm);
  }

  public updateInfo() : void {
    const body = this._helperService.createFeedbackRequest(this.feedbackForm.value);
    console.log(body);
    this._poBuyerService.updatePOConfirmation(body).subscribe((res) => {
      this.closeModal(true);
      this._toastr.success(res.data);
    })
  }

}
